<template>
  <div class="ide-template-editor" :class="{blank: files.length === 0}">
    <!-- 文件列表 -->
    <div v-if="files.length > 0" class="editor__file-list">
      <ul class="file-list">
        <li
          v-for="template in files"
          :key="`startup_${template.frontId}`"
          :class="{focus: template.frontId === currentFile.frontId, 'is-edited': template.__isEdited}"
          @click="openFile(template)"
        >
          <i v-if="template.saving" class="el-icon-loading"></i>
          <i class="icon icon-picture" v-else-if="template[viewTypeKey] === 'image'"></i>
          <i v-else class="icon" :class="{[template.lang]: true}"></i>
          {{template.displayName}}
          <i class="el-icon-close" @click.stop="closeFile(template)"></i>
        </li>
      </ul>
      <el-dropdown v-if="files.length > 0" trigger="click" @command="handleCommand">
        <span class="el-dropdown-link">
          <i class="icon icon-menu"></i>
        </span>
        <el-dropdown-menu slot="dropdown">
          <el-dropdown-item command="__closeAll">关闭所有</el-dropdown-item>
          <el-dropdown-item command="__closeLeft">关闭当前左侧</el-dropdown-item>
          <el-dropdown-item command="__closeRight">关闭当前右侧</el-dropdown-item>
        </el-dropdown-menu>
      </el-dropdown>
    </div>
    <!-- 当前文件面包屑 -->
    <ul v-if="currentFilePaths.length > 0" class="editor__file-crumbs">
      <template v-for="(path, index) in currentFilePaths">
        <li :key="`char_${path}_${index}`" v-if="index > 0" class="seg">/</li>
        <li :key="`path_${path}_${index}`">{{path}}</li>
      </template>
    </ul>
    <!-- 编辑器 -->
    <div
      v-for="template in files"
      :id="`fileEditor${template.frontId}`"
      :key="`editor_${template.frontId}`"
      :class="{'file-editor': true, current: template.frontId === currentFile.frontId}"
    >
      <FileEditor
        :ref="`fileEditor${template.frontId}`"
        :file="template"
        :read-only="readOnly"
        :with-tabs="withTabs"
        :view-type-key="viewTypeKey"
        @change="$emit('content-change', $event)"
        @save="$emit('save', $event)"
      />
    </div>
    <!-- 占位 -->
    <div v-show="files.length === 0" class="code-holder">
      <p class="width-80"></p>
      <p class="width-60"></p>
      <p class="width-55 hl-important2"></p>
      <p class="width-65"></p>
      <p class="width-30 hl-important1"></p>
      <p class="width-55"></p>
      <p class="width-80"></p>
      <p class="width-60"></p>
      <p class="width-55 hl-important2"></p>
      <p class="width-65"></p>
      <p class="width-65 hl-important1"></p>
      <p class="width-30"></p>
      <p class="width-30"></p>
      <p class="width-80"></p>
      <p class="width-60"></p>
      <p class="width-55 hl-important2"></p>
      <p class="width-65"></p>
      <p class="width-50 hl-important1"></p>
      <p class="width-30"></p>
      <p class="width-65"></p>
      <p class="width-80"></p>
      <p class="width-60"></p>
      <p class="width-55 hl-important2"></p>
      <p class="width-65"></p>
      <p class="width-50 hl-important1"></p>
      <p class="width-30"></p>
    </div>
  </div>
</template>

<script>
import FileEditor from './FileEditor'
import { parsePath } from '../utils'
export default {
  name: 'IDEEditor',
  components: { FileEditor },
  props: {
    // 需要被打开的文件对象列表
    files: {
      type: Array,
      default () {
        return []
      }
    },
    // 编辑器标记关键字
    markWord: {
      type: String,
      default: null
    },
    // 是否只读
    readOnly: {
      type: Boolean,
      default: false
    },
    // 是否需要文件页签
    withTabs: {
      type: Boolean,
      default: true
    },
    // 输出路径字段名称
    outputPathKey: {
      type: String,
      default: 'outputPath'
    },
    // viewType字段
    viewTypeKey: {
      type: String,
      default: 'viewType'
    }
  },
  data () {
    return {
      // 当前打开的文件
      currentFile: this.files[0],
      // 当前打开的文件的路径数组
      currentFilePaths: []
    }
  },
  watch: {
    files () {
      if (this.files.length === 0) {
        this.currentFile = null
        this.currentFilePaths.splice(0, this.currentFilePaths.length)
        return
      }
      this.openFile(this.files[0])
      this.__clearDisplayName()
      this.__initDiffFileName()
    },
    markWord () {
      if (this.currentFile == null) {
        return
      }
      this.markWords(this.currentFile)
    }
  },
  methods: {
    // 重新调整大小
    resize () {
      if (this.currentFile != null) {
        this.$refs['fileEditor' + this.currentFile.frontId][0].resize()
      }
      // for (const template of this.files) {
      //   this.$refs['fileEditor' + template.frontId][0].resize()
      // }
    },
    // 关闭文件
    closeFile (file) {
      this.files.splice(this.files.findIndex(f => f.frontId === file.frontId), 1)
      this.currentFile = null
    },
    // 打开文件
    openFile (file) {
      if (this.currentFile != null) {
        if (this.currentFile.frontId === file.frontId) {
          return
        }
        // 延时隐藏原编辑器
        const currentfrontId = this.currentFile.frontId
        this.$nextTick(() => {
          document.getElementById(`fileEditor${currentfrontId}`).style.display = 'none'
        })
      }
      this.currentFile = file
      this.currentFilePaths = parsePath(`${this.currentFile[this.outputPathKey]}/${this.currentFile.name}`)
      // 清除目标编辑器的display
      const domTargetFileEditor = document.getElementById(`fileEditor${file.frontId}`)
      if (domTargetFileEditor != null) {
        domTargetFileEditor.style = {}
        this.$refs['fileEditor' + file.frontId][0].resize()
      }
      // 执行标记
      this.markWords(file)
    },
    // 标记内容
    markWords (file) {
      if (file.viewType === 'code' || file.fileViewType === 'code') {
        this.$nextTick(() => {
          this.$refs[`fileEditor${file.frontId}`][0].markWords(this.markWord)
        })
      }
    },
    // 处理菜单选项
    handleCommand (command) {
      this[command]()
    },
    // 获取当前打开的文件对象
    getCurrentFile () {
      return this.currentFile
    },
    refresh () {
      this.__clearDisplayName()
      this.__initDiffFileName()
      if (this.currentFile != null) {
        this.currentFilePaths = parsePath(`${this.currentFile[this.outputPathKey]}/${this.currentFile.name}`)
      }
    },
    // 清理展示名称，避免文件名称修改后不生效
    __clearDisplayName () {
      for (const template of this.files) {
        delete template.displayName
      }
    },
    /**
     * 初始化不同的文件名称
     * - 存在a/b/d/f/A.java和b/c/f/A.java，此时如果均展示A.java无法区分文件，需要逐渐在文件名称钱添加路径来处理
     * @author Caesar Liu
     * @date 2020-11-17 15:47
     */
    __initDiffFileName (continueCount = 0) {
      const nameMap = {}
      for (const template of this.files) {
        template.displayName = template.displayName == null ? template.name : template.displayName
        const nameKey = `$${template.displayName}`
        if (nameMap[nameKey] == null) {
          nameMap[nameKey] = []
        }
        nameMap[nameKey].push(template)
      }
      let continueDiff = false
      for (const key in nameMap) {
        if (nameMap[key].length === 1) {
          continue
        }
        continueDiff = true
        for (const file of nameMap[key]) {
          const filePaths = parsePath(file[this.outputPathKey])
          const path = filePaths[filePaths.length - continueCount - 1]
          file.displayName = `${path}/${file.displayName}`
          /*
           如果获取路径部分已经为null，则说明一个目录下存在同名文件（包含后缀），这是错误的数据。
           如：a/b/c/A.java和a/b/c/A.java
           这会导致名为a/b/c/A.java的名称映射始终存在2条记录，从而出现无限递归。在这里做特殊处理，将两个文件名称均展示为a/b/c/A.java即可。
           */
          if (path == null) {
            continueDiff = false
            file.displayName = file.displayName.substring(file.displayName.indexOf('/') + 1)
          }
        }
      }
      if (continueDiff) {
        this.__initDiffFileName(++continueCount)
      }
    },
    // 关闭所有
    __closeAll () {
      this.currentFile = null
      this.files.splice(0, this.files.length)
    },
    // 关闭左侧
    __closeLeft () {
      const currentFileIndex = this.files.findIndex(f => f.frontId === this.currentFile.frontId)
      this.files.splice(0, currentFileIndex)
    },
    // 关闭右侧
    __closeRight () {
      const currentFileIndex = this.files.findIndex(f => f.frontId === this.currentFile.frontId)
      this.files.splice(currentFileIndex + 1)
      this.$nextTick(() => {
        this.currentFile = this.files[currentFileIndex]
      })
    }
  }
}
</script>

<style scoped lang="scss">
@import "../variables";
@import "../mixins";
$list-height: 26px;
.ide-template-editor {
  height: 100%;
  padding-top: $list-height;
  position: relative;
  overflow: hidden;
  background-color: $code-space-background;
  &.blank {
    padding-top: 0;
  }
  // 文件列表
  .editor__file-list {
    height: $list-height;
    position: absolute;
    left: 0;
    top: 0;
    width: 100%;
    // 文件列表
    ul.file-list {
      height: 100%;
      overflow: hidden;
      position: absolute;
      left: 0;
      top: 0;
      right: 30px;
      z-index: 9;
      transition: background ease 0.15s;
      display: flex;
      // 文件项
      li {
        display: inline-block;
        cursor: default;
        background: $code-space-background;
        font-size: 13px;
        padding: 0 5px 0 10px;
        border-bottom: 3px solid transparent;
        border-left: 1px solid $color-gray-deep;
        color: $color-white;
        &.is-edited {
          color: $primary-color;
        }
        &:hover {
          color: $color-white;
        }
        &.focus {
          background: #5B6163;
          border-bottom-color: #35A8C0;
        }
        & > * {
          vertical-align: middle;
        }
        // 语言图标
        & > .icon, & > .el-icon-loading {
          width: $list-height;
          height: $list-height;
          position: relative;
          left: 1px;
          margin-right: 1px;
        }
        & > .el-icon-loading {
          font-size: 16px;
          line-height: 21px;
          text-align: center;
        }
        // 关闭图标
        & > .el-icon-close {
          width: $list-height;
          height: $list-height;
          color: $color-gray;
          display: inline-flex;
          align-items: center;
          justify-content: center;
          &:hover {
            color: $color-gray + 10;
          }
        }
      }
    }
    // 文件菜单
    .el-dropdown {
      width: 30px;
      flex-shrink: 0;
      text-align: right;
      position: absolute;
      top: 3px;
      right: 0;
      .el-dropdown-link {
        padding-right: 3px;
        .icon-menu {
          background-size: 22px;
        }
      }
    }
  }
  // 文件面包屑
  .editor__file-crumbs {
    list-style: none;
    border-top: 1px solid $color-gray-deep;
    border-bottom: 1px solid $color-gray-deep;
    height: 26px;
    line-height: 26px;
    color: $color-white;
    padding-left: 10px;
    display: flex;
    font-size: 12px;
    li {
      &.seg {
        padding: 0 6px;
        color: #777;
      }
      &:last-of-type {
        font-weight: bold;
        color: $color-white;
      }
    }
  }
  // 编辑器
  .file-editor {
    position: absolute;
    width: 100%;
    top: 54px;
    bottom: 0;
    opacity: 0;
    z-index: 2;
    transition: opacity ease .15s;
    &.current {
      opacity: 1;
      display: block;
      z-index: 1;
    }
  }
  // 空文件提示
  .code-holder {
    padding: 30px;
    p {
      height: 14px;
      margin-bottom: 34px;
      background: #444;
      opacity: 0.2;
    }
    .hl-important1 {
      background-color: $primary-color;
      opacity: 0.1;
    }
    .hl-important2 {
      background-color: #333;
      opacity: 1;
    }
    .width-80 {
      width: 80%;
    }
    .width-65 {
      width: 65%;
    }
    .width-60 {
      width: 60%;
    }
    .width-55 {
      width: 55%;
    }
    .width-50 {
      width: 50%;
    }
    .width-30 {
      width: 30%;
    }
  }
}
</style>
